import {ActionTree, MutationTree, GetterTree} from 'vuex'
import {RootState} from '@/store/types'
import VueI18n from '../../helpers/i18n';
import api from "@/service/api";


export interface State {
    isErrorSendTestEmail: boolean
    ShowMailConfiguration: any
    loading: boolean
    loadingSendTest: boolean
    loadingDeleteConnection: boolean
    status_connect: boolean | null
    loadImportList: boolean
    loadingPatch: boolean
    importList: any[] | null
}

const defaultState: State = {
    isErrorSendTestEmail: false,
    ShowMailConfiguration: null,
    loading: true,
    loadImportList: true,
    loadingSendTest: false,
    loadingPatch: false,
    loadingDeleteConnection: false,
    status_connect: null,
    importList: []

};

const getters: GetterTree<State, RootState> = {
    isErrorSendTestEmail: (state: State) => state.isErrorSendTestEmail,
    importList: (state: State) => state.importList,
    loadingPatch: (state: State) => state.loadingPatch,
    loadImportList: (state: State) => state.loadImportList,
    loadingDeleteConnection: (state: State) => state.loadingDeleteConnection,
    GetShowMailConfiguration: (state: State) => state.ShowMailConfiguration,
    loading: (state: State) => state.loading,
    loadingSendTest: (state: State) => state.loadingSendTest,
    status_connect: (state: State) => state.status_connect,
}

const mutations: MutationTree<State> = {
    setSendTestEmail(state: State, payload: boolean) {
        state.isErrorSendTestEmail = payload
    },
    importList(state: State, payload: any) {
        state.importList = payload
    },
    status_connect(state: State, payload: any) {
        state.status_connect = payload
    },
    loadingDeleteConnection(state: State, payload: any) {
        state.loadingDeleteConnection = payload
    },
    loadingSendTest(state: State, payload: any) {
        state.loadingSendTest = payload
    },
    changeConfig(state: State, payload: any) {
        state.ShowMailConfiguration = payload
    },
    setShowMailConfiguration(state: State, payload: any) {
        state.ShowMailConfiguration = payload
    },
    setloading(state: State, payload: any) {
        state.loading = payload
    },
}

const actions: ActionTree<State, RootState> = {
    async deleteMailConfiguration({commit, state}, payload: any) {
        try {
            commit('loadingDeleteConnection', true)
            const {data} = await api.go('deleteMailConfiguration', {
                params: {
                    idConfig: payload
                }
            })
            if (data.error) {
                throw (data.error)
            }
            commit(
                'setShowMailConfiguration',
                null
            )
            commit(
                'status_connect',
                null
            )
        } catch (e) {
            this.commit('alerts/setAlert', {
                show: true,
                messages: [e.message]
            })
        } finally {
            commit('loadingDeleteConnection', false)
        }
    },
    async getMailConfiguration({commit, state}, payload: any) {
        try {
            commit('setloading', true)
            const {data} = await api.go('getMailConfiguration', {
                params: {
                    idPartisipation: payload
                }
            })
            if (data.error) {
                throw (data.error)
            }
            commit(
                'setShowMailConfiguration',
                data.data.showMailConfiguration
            )
        } catch (e) {
            this.commit('alerts/setAlert', {
                show: true,
                messages: [e]
            })
        } finally {
            commit('setloading', false)
        }
    },
    async sendTestEmail({commit, state}, payload: any) {
        try {
            commit('loadingSendTest', true)
            const {data} = await api.go('sendTestEmail', payload)

            if (data.data.status !== 'ok') {
                throw ('errorSendMailTest')
            }
            this.commit('alerts/setAlert', {
                show: true,
                messages: [VueI18n.t('mailing.config.mail_sent')]
            })
            return true


        } catch (e) {
            commit('setSendTestEmail', true)
            this.commit('alerts/setAlert', {
                show: true,
                messages: [VueI18n.t('error.modal.title_some')]
            })
            return false
        } finally {
            commit('loadingSendTest', false)

        }
    },
    async saveMailConfiguration({commit, state}, payload: any) {
        try {
            commit(
                'status_connect',
                'wait'
            )
            console.log(payload)
            // commit('loadingSaveMailConfiguration', true)
            const {data} = await api.go('saveMailConfiguration', payload)

            commit(
                'setShowMailConfiguration',
                {...payload.body, id: data.data.mailConfiguration.id}
            )
            commit(
                'status_connect',
                data.data.mailConfiguration.status.isSuccessful ? 'success' : "error"
            )

            this.commit('alerts/setAlert', {
                show: true,
                messages: [VueI18n.t('mailing.status.save')]
            })
        } catch (e) {
            this.commit('alerts/setAlert', {
                show: true,
                color: 'red',
                messages: [VueI18n.t('error.modal.title_some')]
            })
        } finally {
            // commit('loadingSaveMailConfiguration', false)
        }
    },
    async getStatusMailConfiguration({commit, state}, payload: any) {
        try {
            commit(
                'status_connect',
                'wait'
            )
            const {data} = await api.go('getStatusMailConfiguration', payload)

            commit(
                'status_connect',
                data.data.mailConnectionStatus.isSuccessful ? 'success' : "error"
            )


        } catch (e) {
            console.log(e)
            this.commit('alerts/setAlert', {
                show: true,
                messages: [VueI18n.t('error.modal.title_some')]
            })
        } finally {
            // commit('loadingSaveMailConfiguration', false)
        }
    },
    async getImportListMailConfiguration({commit, state}, payload: any) {
        try {
            state.loadImportList = true
            const {data} = await api.go('getImportListMailConfiguration', payload)
            console.log()
            commit('importList', data.data.showMailConfigurations.filter((el: any) => el.show.code !== payload.showCode))
        } catch (e) {
            this.commit('alerts/setAlert', {
                show: true,
                messages: [VueI18n.t('error.modal.title_some')]
            })
        } finally {
            state.loadImportList = false
        }
    },
    async pathConfigMailConfiguration({commit, state}, payload: any) {
        try {
            state.loadingPatch = true
           await api.go('pathConfigMailConfiguration', payload)
            this.commit('alerts/setAlert', {
                show: true,
                messages: [VueI18n.t('mailing.status.save')]
            })

        } catch (e) {
            this.commit('alerts/setAlert', {
                show: true,
                messages: [VueI18n.t('error.modal.title_some')]
            })
        } finally {
            state.loadingPatch = false
        }
    }
}

export default {
    namespaced: true,
    state: defaultState,
    getters,
    mutations,
    actions
}
